import React from "react";
import { RotateCcw, Search } from "lucide-react";
import PortalSelect from "./PortalSelect";

export type ShipmentFilterBarFilter = {
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  options: string[];
  labels?: Record<string, string>;
};

type ShipmentFilterBarProps = {
  filters: ShipmentFilterBarFilter[];
  search: string;
  onSearchChange: (value: string) => void;
  onClear: () => void;
};

/** Shared shipment and analytics filter strip. It deliberately scrolls rather
 * than wrapping, so every portal view keeps the same field order and sizing. */
export default function ShipmentFilterBar({
  filters,
  search,
  onSearchChange,
  onClear,
}: ShipmentFilterBarProps) {
  return (
    <section className="shipment-filter-bar mt-3 overflow-x-auto border border-slate-200 bg-white p-3 dark:border-white/10 dark:bg-slate-900">
      <div className="flex min-w-max items-center gap-2">
        {filters.map((filter) => (
          <label key={filter.label} className="flex h-10 w-[132px] shrink-0 items-center gap-2 border border-slate-200 bg-slate-50 px-3 text-xs font-semibold dark:border-white/10 dark:bg-slate-950">
            <span className="shrink-0 text-[9px] uppercase text-slate-500">{filter.label}</span>
            <PortalSelect multiple value={filter.value} onChange={filter.onChange} ariaLabel={filter.label} className="min-w-0 flex-1" highlightActive options={filter.options.map((option) => ({ value: option, label: filter.labels?.[option] || option }))} />
          </label>
        ))}
        <label className="flex h-10 w-52 shrink-0 items-center gap-2 border border-slate-200 bg-slate-50 px-3 dark:border-white/10 dark:bg-slate-950">
          <Search className="h-4 w-4 shrink-0 text-slate-500" />
          <input value={search} onChange={(event) => onSearchChange(event.target.value)} placeholder="Search" className="min-w-0 flex-1 bg-transparent text-xs font-semibold outline-none" />
        </label>
        <button type="button" onClick={onClear} aria-label="Clear filters" title="Clear filters" className="grid h-10 w-10 shrink-0 place-items-center border border-slate-200 text-slate-500 transition-colors hover:border-orange-400 hover:text-orange-500 dark:border-white/10">
          <RotateCcw className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
